import { DialogService } from 'aurelia-dialog';
import { CustomCancel } from './CustomCancel/CustomCancel';
import { YesNoCancel } from './YesNoCancel/YesNoCancel';
import { OkCancel } from './OkCancel/OkCancel';
import { autoinject } from 'aurelia-framework';
import { ObjectHelper } from '../Helpers/ObjectHelper';

@autoinject
export class PromptController {

    private _dialogService: DialogService = null;

    constructor(dialogService: DialogService) {
        this._dialogService = dialogService;
    }

    public async CustomCancel(message: string, title?: string, disableCancel?: boolean, buttons?: Array<Object>) {
        let disableCancelTmp = (ObjectHelper.IsNullOrUndefined(disableCancel) ? false : disableCancel)

        return await this._dialogService.open({ viewModel: CustomCancel, model: { title: title, message: message, disableCancel: disableCancelTmp, buttons: buttons } }).whenClosed(response => {
            
            if (response.wasCancelled) {
                return 'cancel';
            } else {
                return response.output;
            }
        });
    }

    public async YesNoCancel(message: string, title?: string, disableCancel?: boolean) {
        let disableCancelTmp = (ObjectHelper.IsNullOrUndefined(disableCancel) ? false : disableCancel)

        return await this._dialogService.open({ viewModel: YesNoCancel, model: { title: title, message: message, disableCancel: disableCancelTmp } }).whenClosed(response => {
            
            if (response.wasCancelled) {
                return 'cancel';
            } else {
                return response.output;
            }
        });
    }

    public async OKCancel(message: string, title?: string, disableCancel?: boolean) {
        let disableCancelTmp = (ObjectHelper.IsNullOrUndefined(disableCancel) ? false : disableCancel)

        return await this._dialogService.open({ viewModel: OkCancel, model: { title: title, message: message, disableCancel: disableCancelTmp } }).whenClosed(response => {
            
            if (response.wasCancelled) {
                return 'cancel';
            } else {
                return 'ok';
            }
        });
    }
}